import React, { useState } from "react";
import { Checkbox as Check } from "antd";

const Checkbox = ({ description, pstyle, fontColor, link, onChecked }) => {
  const [isChecked1, setIsChecked1] = useState(false);

  const onChange1 = (e) => {
    setIsChecked1(!isChecked1);
    onChecked(e.target.checked);
  };

  const checkboxStyle = {
    "--checkbox-inner-color": isChecked1 ? "rgba(43, 207, 231, 1)" : "#f0f0f0",
  };

  return (
    <div className="flex items-center ">
      <Check checked={isChecked1} onChange={onChange1} style={checkboxStyle} />
      <p
        style={{ marginLeft: "8px", display: "block" }}
        className={fontColor ? fontColor : "pstyle  font-medium"}
      >
        {description}
        {link}
      </p>
      <style>{`
    .ant-checkbox-checked .ant-checkbox-inner,
    .ant-checkbox-inner:not(.ant-checkbox-checked) {
      background-color: var(--checkbox-inner-color) !important;
      border-color: var(--checkbox-inner-color) !important;
    }
  `}</style>
    </div>
  );
};

export default Checkbox;
